'use client'

import Bugsnag from '@bugsnag/js'
import React, { useEffect } from 'react'

import CustomError from '@/components/Page/CustomError/CustomError'

// eslint-disable-next-line no-unused-vars
export default function Error({ error }: { error: Error }) {
  useEffect(() => {
    try {
      Bugsnag.notify(error)
      console.error(error)
    } catch (error) {
      console.error('bugsnag crashed.')
      console.error(error)
    }
  }, [error])
  return <CustomError headingText={`Server Error.`} text="エラーが発生しました。" header={false} />
}
